import { useState, useEffect } from "react";
import { useToast } from "@/shared/hooks/use-toast";

interface UseImagePreviewOptions {
  maxSize?: number; // Max size in KB
  initialImage?: string | null;
}

export const useImagePreview = ({
  maxSize = 500,
  initialImage = null,
}: UseImagePreviewOptions = {}) => {
  const { toast } = useToast();
  const [imagePreview, setImagePreview] = useState<string | null>(initialImage);
  const [imageError, setImageError] = useState<string | null>(null);

  // Update imagePreview when initialImage changes
  useEffect(() => {
    if (initialImage) {
      setImagePreview(initialImage);
    }
  }, [initialImage]);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImageError(null);

    if (file.size > maxSize * 1024) {
      const errorMsg = `A imagem deve ter no máximo ${maxSize}KB`;
      setImageError(errorMsg);
      toast({
        title: "Erro ao carregar imagem",
        description: errorMsg,
        variant: "destructive",
      });
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const removeImagePreview = () => {
    setImagePreview(null);
    setImageError(null);
  };

  return {
    imagePreview,
    imageError,
    setImagePreview,
    handleImageChange,
    removeImagePreview,
  };
};
